import { Immutable } from "immer";
import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<
    React.SelectHTMLAttributes<HTMLSelectElement> & { noBorder?: boolean }
>;

export const UnstyledSelect = ({
    noBorder,
    className,
    ...props
}: IProps): React.JSX.Element => {
    return (
        <select
            {...props}
            className={concatClassNames([
                styles.selectNotStyled,
                noBorder ? styles.selectNoBorder : null,
                className,
            ])}
        />
    );
};
